import React, { useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import Box from 'carbon-react/lib/components/box';
import { useIntl } from 'react-intl';

import { getReportingUrl, matchConsolidationDetailRoutePath } from '@futrli/shared-services';
import { ListingPageTabs } from '@futrli/ui-components/components/listing-page/listing-page-tabs/listing-page-tabs';
import { useNavHeight } from '../../../hooks/useNavHeight';
import { MyReportsTab } from './my-reports/my-reports-tab';
import { ExportedPdfsTab } from './exported-pdfs/exported-pdfs-tab';
import { ReportSchedulingTab } from './report-scheduling/report-scheduling-tab';
import { ReportTemplatesTab } from './report-templates/report-templates-tab';

export enum ReportingTabId {
  REPORTS_LIST = 'reports-list',
  REPORT_SCHEDULING = 'report-scheduling',
  EXPORTED_PDFS = 'exported-pdfs',
  REPORT_TEMPLATES = 'report-templates'
}

export const ReportingTabs = () => {
  const intl = useIntl();
  const location = useLocation();
  const { navHeight } = useNavHeight();
  const { workspaceId = '', organisationId = '' } = useParams();
  const isConsolidation = !!matchConsolidationDetailRoutePath(location.pathname);

  const basePath = getReportingUrl(workspaceId, organisationId, isConsolidation);

  const tabs = useMemo(
    () => [
      {
        id: ReportingTabId.REPORTS_LIST,
        title: intl.formatMessage({ id: 'predict.reports_list', defaultMessage: 'Reports list' }),
        component: <MyReportsTab />
      },
      {
        id: ReportingTabId.REPORT_SCHEDULING,
        title: intl.formatMessage({ id: 'predict.report_scheduling', defaultMessage: 'Report scheduling' }),
        component: <ReportSchedulingTab />
      },
      {
        id: ReportingTabId.EXPORTED_PDFS,
        title: intl.formatMessage({ id: 'predict.exported_pdfs_v2', defaultMessage: 'PDF history' }),
        component: <ExportedPdfsTab />
      },
      {
        id: ReportingTabId.REPORT_TEMPLATES,
        title: intl.formatMessage({ id: 'predict.report_templates', defaultMessage: 'Report templates' }),
        component: <ReportTemplatesTab />
      }
    ],
    [intl]
  );

  return (
    <Box mt={3}>
      <ListingPageTabs stickyTop={navHeight} tabs={tabs} basePath={basePath} mountActiveTabOnly />
    </Box>
  );
};
